export const CATEGORY_AR = {
  "Latest": "الأحدث",
  "Market News": "أخبار السوق",
  "Technical Analysis": "تحليل فني",
  "Fundamental Analysis": "تحليل أساسي",
  "Forex Analysis": "تحليل الفوركس",
  "Gold Analysis": "تحليل الذهب",
  "Weekly Outlook": "التوقعات الأسبوعية",
};

export const EDU_LEVEL_AR = {
  "Beginner": "مبتدئ",
  "Forex": "الفوركس",
  "Technical Analysis": "التحليل الفني",
  "Fundamental Analysis": "التحليل الأساسي",
  "Risk Management": "إدارة المخاطر",
  "Trading Psychology": "سيكولوجية التداول",
  "Platforms": "المنصات",
  "Trading Strategies": "استراتيجيات التداول",
};

// Return the localized value of a doc field, falling back to the base field.
export function loc(obj, field, isAr) {
  if (!obj) return "";
  if (isAr && obj[`${field}_ar`]) return obj[`${field}_ar`];
  return obj[field];
}

// Return the localized array of a doc field, falling back to the base array.
export function locArr(obj, field, isAr) {
  if (!obj) return [];
  const ar = obj[`${field}_ar`];
  if (isAr && Array.isArray(ar) && ar.length) return ar;
  return Array.isArray(obj[field]) ? obj[field] : [];
}

export function catLabel(cat, isAr) {
  return isAr && CATEGORY_AR[cat] ? CATEGORY_AR[cat] : cat;
}

export function levelLabel(level, isAr) {
  return isAr && EDU_LEVEL_AR[level] ? EDU_LEVEL_AR[level] : level;
}
